export const FONTS = {
  HeadlineExtra5: `--fonts-headline-extra-5`,
  HeadlineExtra10: `--fonts-headline-extra-10`,
  Headline1: `--fonts-headline-1`,
  Headline2: `--fonts-headline-2`,
  Headline3: `--fonts-headline-3`,
  Headline4: `--fonts-headline-4`,
  Footnote1: `--fonts-footnote-1`,
  Footnote2: `--fonts-footnote-2`,
  Footnote3: `--fonts-footnote-3`,
  Footnote4: `--fonts-footnote-4`,
  Footnote5: `--fonts-footnote-5`,
  Footnote6: `--fonts-footnote-6`,
  Body1: `--fonts-body-1`,
  Body2: `--fonts-body-2`,
  Body3: `--fonts-body-3`,
  Body4: `--fonts-body-4`,
  Body5: `--fonts-body-5`,
  Caption1: `--fonts-caption-1`,
  Caption2: `--fonts-caption-2`,
  Caption3: `--fonts-caption-3`,
  Caption4: `--fonts-caption-4`,
  Caption5: `--fonts-caption-5`,
  Button1: `--fonts-button-1`,
  Button2: `--fonts-button-2`,
  Button3: `--fonts-button-3`,
  Font5xl: `--fonts-font-5-xl`,
  Font5xlBold: `--fonts-font-5-xl-bold`,
  Font4xl: `--fonts-font-4-xl`,
  Font4xlBold: `--fonts-font-4-xl-bold`,
  Font3xl: `--fonts-font-3-xl`,
  Font3xlBold: `--fonts-font-3-xl-bold`,
  Font2xl: `--fonts-font-2-xl`,
  Font2xlBold: `--fonts-font-2-xl-bold`,
  FontXl: `--fonts-font-xl`,
  FontXlBold: `--fonts-font-xl-bold`,
  FontLg: `--fonts-font-lg`,
  FontLgBold: `--fonts-font-lg-bold`,
  FontSm: `--fonts-font-sm`,
  FontSmBold: `--fonts-font-sm-bold`,
  FontMdToSm: `--fonts-font-md-to-sm`,
  FontMdToSmBold: `--fonts-font-md-to-sm-bold`,
  FontXs: `--fonts-font-xs`,
  FontXsBold: `--fonts-font-xs-bold`,
} as const
export type FONTS = (typeof FONTS)[keyof typeof FONTS]

export const FONT_FAMILY = {
  MAIN: '--font-family-main',
} as const
export type FONT_FAMILY = (typeof FONT_FAMILY)[keyof typeof FONT_FAMILY]
